export enum Permissions {
	GET_MY_PROFILE = "GET_MY_PROFILE",
	UPDATE_MY_PROFILE = "UPDATE_MY_PROFILE",
	DELETE_MY_PROFILE = "DELETE_MY_PROFILE",
	CHANGE_PASSWORD_MY_PROFILE = "CHANGE_PASSWORD_MY_PROFILE",
	CREATE_USER = "CREATE_USER",
	UPDATE_USER = "UPDATE_USER",
	SINGLE_USER = "SINGLE_USER",
	LIST_USER = "LIST_USER",
	DELETE_USER = "DELETE_USER",
	ACTIVATE_USER = "ACTIVATE_USER",
	DEACTIVATE_USER = "DEACTIVATE_USER",
	CHANGE_PASSWORD_USER = "CHANGE_PASSWORD_USER",
	CREATE_GLOBAL_SETTING = "CREATE_GLOBAL_SETTING",
	UPDATE_GLOBAL_SETTING = "UPDATE_GLOBAL_SETTING",
	SINGLE_GLOBAL_SETTING_BY_KEY = "SINGLE_GLOBAL_SETTING_BY_KEY",
	SINGLE_GLOBAL_SETTING = "SINGLE_GLOBAL_SETTING",
	LIST_GLOBAL_SETTING = "LIST_GLOBAL_SETTING",
	DELETE_GLOBAL_SETTING = "DELETE_GLOBAL_SETTING",
	CREATE_PLAN = "CREATE_PLAN",
	UPDATE_PLAN = "UPDATE_PLAN",
	SINGLE_PLAN = "SINGLE_PLAN",
	SINGLE_PLAN_BY_SLUG = "SINGLE_PLAN_BY_SLUG",
	LIST_PLAN = "LIST_PLAN",
	LIST_INCOME_SOURCE_PLAN = "LIST_INCOME_SOURCE_PLAN",
	DELETE_PLAN = "DELETE_PLAN",
	CREATE_EFILING_PLAN = "CREATE_EFILING_PLAN",
	UPDATE_EFILING_PLAN = "UPDATE_EFILING_PLAN",
	SINGLE_EFILING_PLAN = "SINGLE_EFILING_PLAN",
	LIST_EFILING_PLAN = "LIST_EFILING_PLAN",
	DELETE_EFILING_PLAN = "DELETE_EFILING_PLAN",
	CREATE_EFILING_PLAN_TRANSACTION = "CREATE_EFILING_PLAN_TRANSACTION",
	UPDATE_EFILING_PLAN_TRANSACTION = "UPDATE_EFILING_PLAN_TRANSACTION",
	SINGLE_EFILING_PLAN_TRANSACTION = "SINGLE_EFILING_PLAN_TRANSACTION",
	LIST_EFILING_PLAN_TRANSACTION = "LIST_EFILING_PLAN_TRANSACTION",
	DELETE_EFILING_PLAN_TRANSACTION = "DELETE_EFILING_PLAN_TRANSACTION",
	CREATE_EFILING = "CREATE_EFILING",
	UPDATE_EFILING = "UPDATE_EFILING",
	SINGLE_EFILING = "SINGLE_EFILING",
	LIST_EFILING = "LIST_EFILING",
	DELETE_EFILING = "DELETE_EFILING",
	CREATE_EFILING_MESSAGE_CHANNEL = "CREATE_EFILING_MESSAGE_CHANNEL",
	UPDATE_EFILING_MESSAGE_CHANNEL = "UPDATE_EFILING_MESSAGE_CHANNEL",
	SINGLE_EFILING_MESSAGE_CHANNEL = "SINGLE_EFILING_MESSAGE_CHANNEL",
	LIST_EFILING_MESSAGE_CHANNEL = "LIST_EFILING_MESSAGE_CHANNEL",
	DELETE_EFILING_MESSAGE_CHANNEL = "DELETE_EFILING_MESSAGE_CHANNEL",
	CREATE_EFILING_MESSAGE = "CREATE_EFILING_MESSAGE",
	UPDATE_EFILING_MESSAGE = "UPDATE_EFILING_MESSAGE",
	SINGLE_EFILING_MESSAGE = "SINGLE_EFILING_MESSAGE",
	LIST_EFILING_MESSAGE = "LIST_EFILING_MESSAGE",
	DELETE_EFILING_MESSAGE = "DELETE_EFILING_MESSAGE",
	CREATE_EFILING_AUTHORIZED_USER = "CREATE_EFILING_AUTHORIZED_USER",
	DELETE_EFILING_AUTHORIZED_USER = "DELETE_EFILING_AUTHORIZED_USER",
	CREATE_EFILING_DOCUMENT = "CREATE_EFILING_DOCUMENT",
	DELETE_EFILING_DOCUMENT = "DELETE_EFILING_DOCUMENT",

	// Filing status permission
	EFILING_STATUS_CALLED = "EFILING_STATUS_CALLED",
	EFILING_STATUS_CONVERTED = "EFILING_STATUS_CONVERTED",
	EFILING_STATUS_NOT_CONVERTED = "EFILING_STATUS_NOT_CONVERTED",
	EFILING_STATUS_REQUESTED_DETAILS = "EFILING_STATUS_REQUESTED_DETAILS",
	EFILING_STATUS_REQUESTED_DETAILS_RECEIVED = "EFILING_STATUS_REQUESTED_DETAILS_RECEIVED",
	EFILING_STATUS_DETAILS_SENT = "EFILING_STATUS_DETAILS_SENT",
	EFILING_STATUS_RECEIVED_DETAILS = "EFILING_STATUS_RECEIVED_DETAILS",
	EFILING_STATUS_FILE_UNDER_PROCESSING = "EFILING_STATUS_FILE_UNDER_PROCESSING",
	EFILING_STATUS_FILE_PROCESSED = "EFILING_STATUS_FILE_PROCESSED",

	// TODO for testing purpose, comment out during commit.
	TEST = "TEST"
}
